module.exports = __webpack_public_path__ + "img/4-5.924f95a3.svg";